module.exports = __webpack_public_path__ + "static/img/favicon.68ce7c04.png";